var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiconOrganizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02368 9.74207L8.21368 11.9321L13.0237 7.12207",
    stroke: "#178477",
    strokeWidth: 2.04709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0234 18.6415L9.02344 19.2115L8.02344 18.6415C5.89434 17.4123 4.12648 15.6441 2.89767 13.5147C1.66887 11.3854 1.02245 8.96998 1.02344 6.51151C1.0238 6.16078 1.11638 5.81632 1.2919 5.51267C1.46742 5.20902 1.7197 4.95687 2.02344 4.78151L8.10344 1.27151C8.38282 1.10903 8.70025 1.02344 9.02344 1.02344C9.34663 1.02344 9.66406 1.10903 9.94344 1.27151L16.0234 4.78151C16.3272 4.95687 16.5795 5.20902 16.755 5.51267C16.9305 5.81632 17.0231 6.16078 17.0234 6.51151C17.0244 8.96998 16.378 11.3854 15.1492 13.5147C13.9204 15.6441 12.1525 17.4123 10.0234 18.6415Z",
    stroke: "#178477",
    strokeWidth: 2.04709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiconOrganizer);
export default __webpack_public_path__ + "static/media/micon-organizer.a460c0f99adfca66626819e158359d87.svg";
export { ForwardRef as ReactComponent };